import React, { useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import GrabButton from "../../../Button/GrabButton";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import theBG1 from "../../../../assets/images/food2.png";
import AOS from "aos";
import "aos/dist/aos.css";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    color: "white",
    padding: "1rem",
  },
  media: {
    height: 250,
  },
}));

export default function Food() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Card className={classes.root} elevation="0">
      <CardMedia className={classes.media} image={theBG1} title="food" />
      <CardContent>
        <Typography
          gutterBottom
          variant="h5"
          component="h2"
          style={{ fontWeight: 300 }}
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          Thức ăn
        </Typography>
        <Typography
          variant="body2"
          component="p"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          Bún bắp bò là một món ăn dân dã của người Việt và có thể xem đây đại
          diện cho một trong những món ăn tiêu biểu cho nền ẩm thực Việt Nam.
          Giữa các quán bún danh tiếng lâu đời ở bốn phương, người Sài Gòn đặc
          biệt đánh giá bún bắp bò O Như như là món ăn buổi sáng tinh thần. Có
          thể đánh giá, bún bắp bò O Như mang đến giá cả hợp lí, không gian sạch
          sẽ, và mang phong cách thuần Việt trong từng cọng bún.
        </Typography>
      </CardContent>
      <CardActions
        style={{ display: "flex", flexDirection: "column" }}
        data-aos="zoom-in"
        data-aos-duration="1000"
      >
        <GrabButton />
        <Typography
          variant="body1"
          style={{
            padding: theme.spacing(2),
            fontWeight: "bold",
          }}
        >
          HOẶC
        </Typography>
        <Typography variant="body1">
          <a
            href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white", textTransform: "uppercase" }}
          >
            Ăn tại quán!
          </a>
        </Typography>
      </CardActions>
    </Card>
  );
}
